export default __webpack_public_path__ + "static/media/header.910b64d7.svg";